import { http } from "@/configurations/axios";

const post = (url, payload = {}) => http.post(url, payload);

export default {
  inicializacao() {
    return post("/etiquetas/inicializacao");
  },
  modelos() {
    return post("/etiquetas/modelos");
  },
  find(modeloUuid) {
    return post("/etiquetas/modelos/find", { modelo_uuid: modeloUuid });
  },
  criar(payload) {
    return post("/etiquetas/modelos/create", payload);
  },
  iniciarLegado(payload) {
    return post("/etiquetas/modelos/legado/iniciar", payload);
  },
  salvarRascunho(payload) {
    return post("/etiquetas/modelos/rascunho", payload);
  },
  descartarRascunho(modeloUuid, tokenRevisao) {
    return post("/etiquetas/modelos/descartar-rascunho", {
      modelo_uuid: modeloUuid,
      token_revisao: tokenRevisao,
    });
  },
  publicar(payload) {
    return post("/etiquetas/modelos/publicar", payload);
  },
  restaurar(payload) {
    return post("/etiquetas/modelos/restaurar", payload);
  },
  reativarLegado(modeloUuid, tokenRevisao) {
    return post("/etiquetas/modelos/reativar-legado", {
      modelo_uuid: modeloUuid,
      token_revisao: tokenRevisao,
    });
  },
  arquivar(modeloUuid, tokenRevisao) {
    return post("/etiquetas/modelos/arquivar", {
      modelo_uuid: modeloUuid,
      token_revisao: tokenRevisao,
    });
  },
  duplicar(payload) {
    return post("/etiquetas/modelos/duplicar", payload);
  },
  preview(payload) {
    return post("/etiquetas/preview", payload);
  },
  previewPdf(payload) {
    return http.post("/etiquetas/preview-pdf", payload, {
      responseType: "blob",
    });
  },
  impressaoTeste(payload) {
    return post("/etiquetas/impressao-teste", payload);
  },
  buscarEmpresas(busca = "") {
    return post("/etiquetas/empresas/buscar", { busca });
  },
  buscarProdutosExemplo(payload) {
    return post("/etiquetas/produtos/buscar", payload);
  },
  produtoExemplo(payload) {
    return post("/etiquetas/produtos/exemplo", payload);
  },
  codigoImagem(payload) {
    return http.post("/etiquetas/assets/codigo", payload, {
      responseType: "blob",
    });
  },
  logoImagem(idEmpresa) {
    return post("/etiquetas/assets/logo", { id_empresa: idEmpresa });
  },
};
